module.exports = __webpack_public_path__ + "static/media/close.5dc86363.svg";